<ion-header>
    <ion-toolbar>

        <ion-title mode="ios" role="heading">{{ 'FEEDBACK_ZENDESK_HEADER' | translate}}</ion-title>

        <ion-buttons slot="end">
            <ion-button
                class="icon-button-accessible-background-contrast"
                icon-only
                [attr.aria-label]="'ARIA_LABEL_CLOSE' | translate"
                (click)="dismiss()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <div *ngIf="feedbackSubmitError">
        <ion-text *ngIf='formInvalid' aria-live="assertive" color="danger">{{ 'FEEDBACK_ZENDESK_ERROR_FORM' | translate }}</ion-text>
        <ion-text *ngIf='invalidEmail' aria-live="assertive" color="danger">{{ 'FEEDBACK_ZENDESK_ERROR_EMAIL' | translate }}</ion-text>
        <ion-text *ngIf='requestFailed' aria-live="assertive" color="danger">{{ 'FEEDBACK_ZENDESK_ERROR_REQUEST' | translate }}</ion-text>
    </div>

    <p><span id="name_label" [innerHTML]="'FEEDBACK_ZENDESK_NAME' | translate"></span><ion-text color="danger"> *</ion-text></p>
    <ion-item class="item-outline">
        <ion-input
            clearInput
            type="text"
            attr.aria-label="{{ 'FEEDBACK_ZENDESK_NAME' | translate }} {{ 'SURVEY_MESSAGE_REQUIRED' | translate }}"
            [(ngModel)]="name"></ion-input>
    </ion-item>
    <p><span id="email_label" [innerHTML]="'FEEDBACK_ZENDESK_EMAIL' | translate "></span><ion-text color="danger"> *</ion-text></p>
    <ion-item class="item-outline">
        <ion-input
            clearInput
            type="text"
            attr.aria-label="{{ 'FEEDBACK_ZENDESK_EMAIL' | translate }} {{ 'SURVEY_MESSAGE_REQUIRED' | translate }}"
            [(ngModel)]="email" ></ion-input>
    </ion-item>
    <p><span id="feedback_label" [innerHTML]="'FEEDBACK_ZENDESK_FEEDBACK' | translate "></span><ion-text color="danger"> *</ion-text></p>
    <ion-item class='item-textarea item-outline'>
        <ion-textarea
            rows="8"
            attr.aria-label="{{ 'FEEDBACK_ZENDESK_FEEDBACK' | translate }} {{ 'SURVEY_MESSAGE_REQUIRED' | translate }}"
            [(ngModel)]="feedback" ></ion-textarea>
    </ion-item>

    <ion-button
        expand="block"
        class="emphasized-button"
        (click)="submit()"
        [innerHTML]="'FEEDBACK_ZENDESK_BUTTON_SUBMIT' | translate">
    </ion-button>

    <div>
        <p><ion-text color='danger'>*</ion-text>&nbsp;<span [innerHTML]="'FEEDBACK_ZENDESK_FIELD_REQUIRED' | translate "></span><p>
    </div>

</ion-content>